import * as React from 'react'

import { Text } from 'main/ui'
import { Container, Fill, StarsContainer, StyledText } from './RatingDisplay.styles'

const RATING_SCALE = 5

interface IProps {
  count: number
  showLabel?: boolean
  size: number
  value: number
}

export default function RatingDisplay(props: IProps) {
  const { count, showLabel, size, value } = props

  return (
    <Container style={{ fontSize: size }}>
      <StarsContainer>
        <Fill width={fillPercentage(value) * 100} />
      </StarsContainer>
      {showLabel && (
        <StyledText muted style={{ fontSize: size }}>
          {labelDisplay(value)}
        </StyledText>
      )}
      <Text muted style={{ fontSize: size }}>
        &nbsp;({count})
      </Text>
    </Container>
  )
}

const fillPercentage = (value: number) => {
  if (value < 0) return 0
  if (value >= RATING_SCALE) return 1

  const percentage = value / RATING_SCALE

  // Each 10% increment fills a half star
  return Math.round(percentage / 0.1) * 0.1
}

const labelDisplay = (value: number) => {
  return value.toFixed(2).slice(0, -1)
}
